import React from 'react';
import {
  InnerNavigator,
  InnerNavigatorOption,
} from 'components/ui/InnerNavigator';

interface Props extends React.PropsWithChildren<{}> {}

export const StockLayout: React.FC<Props> = ({ children }) => {
  const navigatorOptions: InnerNavigatorOption[] = [
    {
      title: 'Saldo em Estoque',
      route: '/estoque/saldo-estoque',
      hasPermission: true,
    },
    {
      title: 'Pendentes de Regularização',
      route: '/estoque/pendentes-regularizacao',
      hasPermission: true,
    },
  ];

  return (
    <>
      <InnerNavigator options={navigatorOptions} className="mb-[14px]" />
      {children}
    </>
  );
};
